import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
    DraftRevealSsnParams,
    InternalDraftApplicationClient,
    InternalDraftApplicationViewModel,
    SaveInternalDraftRequest,
    PagedListOfInternalDraftListPreview,
    AssistanceApplicationType,
    SimpleStringResult
} from './api.client';

@Injectable({
    providedIn: 'root'
})
export class InternalDraftService {
    private _client = inject(InternalDraftApplicationClient);

    save(request: SaveInternalDraftRequest, existingDraftId?: string | null): Observable<InternalDraftApplicationViewModel> {
        return this._client.save(request, existingDraftId);
    }

    getById(id: string): Observable<InternalDraftApplicationViewModel> {
        return this._client.getById(id);
    }

    getByClientAndType(clientId: string, applicationType: AssistanceApplicationType): Observable<InternalDraftApplicationViewModel[]> {
        return this._client.getByClientAndType(clientId, applicationType);
    }

    search(
        applicationType: AssistanceApplicationType,
        searchValue?: string | null,
        agencyId?: string | null,
        managingAgencyId?: string | null,
        fundTypeIds?: string[] | null,
        limit?: number | null,
        offset?: number | null,
        sortName?: string | null,
        descending?: boolean
    ): Observable<PagedListOfInternalDraftListPreview> {
        return this._client.search(applicationType, searchValue, agencyId, managingAgencyId, fundTypeIds, limit, offset, sortName, undefined, descending);
    }

    getCount(applicationType: AssistanceApplicationType): Observable<number> {
        return this._client.getCount(applicationType);
    }

    delete(id: string): Observable<void> {
        return this._client.delete(id).pipe(map(() => void 0));
    }

    exposeDraftSsn(draftId: string, memberId: string, isAdult: boolean, enteredPassword: string): Observable<SimpleStringResult> {
        const params = new DraftRevealSsnParams({
            draftId,
            memberId,
            isAdult,
            enteredPassword
        });
        return this._client.exposeSsn(params);
    }
}
